import React from 'react';
import VideoGuidaFinestra from '../support/guide/VideoGuidaFinestra';

/** Video guida «I dipendenti dello studio» per i titolari (YouTube, 3 minuti), nel riquadro «I miei dipendenti». */
export const VIDEO_GUIDA_DIPENDENTI_ID = 'nYC42WzhlaA';

export const VIDEO_GUIDA_DIPENDENTI_TITLE = 'Video guida ai dipendenti dello studio';

const VideoGuidaDipendenti: React.FC = () => (
  <VideoGuidaFinestra videoId={VIDEO_GUIDA_DIPENDENTI_ID} titolo={VIDEO_GUIDA_DIPENDENTI_TITLE} durata="3 minuti" variante="compatto" />
);

export default VideoGuidaDipendenti;
